import { cn } from '@/utils/shad';
import { PropsWithChildren, ReactNode } from 'react';

type PaginatedTableLayoutProps = PropsWithChildren<{
  footer?: ReactNode;
  className?: string;
  scrollClassName?: string;
  footerClassName?: string;
  /** `inline` places the footer right after table content; `sticky` pins it to the viewport bottom. */
  footerPlacement?: 'inline' | 'sticky';
}>;

export function PaginatedTableLayout({
  children,
  footer,
  className,
  scrollClassName,
  footerClassName,
  footerPlacement = 'inline',
}: PaginatedTableLayoutProps) {
  const footerNode = footer ? <div className={cn('shrink-0', footerClassName)}>{footer}</div> : null;

  if (footerPlacement === 'sticky') {
    return (
      <div className={cn('flex min-h-0 flex-1 flex-col', className)}>
        <div className={cn('min-h-0 flex-1 overflow-auto', scrollClassName)}>{children}</div>
        {footerNode}
      </div>
    );
  }

  return (
    <div className={cn('flex min-h-0 flex-1 flex-col', className)}>
      <div className={cn('min-h-0 flex-1 overflow-auto', scrollClassName)}>
        {children}
        {footerNode}
      </div>
    </div>
  );
}
